import { FormattedMessage, useIntl } from "react-intl";
import { Button } from "@progress/kendo-react-buttons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import { Alert, CreateModal, Stats } from "@mikros/shared-ui";
import {
  AllCourses,
  CoursesRecieved,
  GetScheduleDetails,
  GetSchedules,
  HomeAnalytics,
  Schedule,
  ScheduleDetails,
  ScheduleResource,
  UserScheduleDetails,
} from "@mikros/library";
import { useEffect, useState } from "react";
import { ScheduleCard } from "../scheduler/scheduleCard";
import ApiServices from "../../service/apiService";
import { useNavigate } from "react-router-dom";
import { ScheduleDetailsFetch } from "../scheduler/createSchedule/scheduleDetailsFetch";
import { CourseCard } from "../courses/courseCard";
import Account from "../../utils/apiConfig";
import { Dialog } from "@progress/kendo-react-dialogs";
import ErrorHandler from "../../utils/errorConfig";

export interface HomeProps {}

export function Home(props: HomeProps) {
  const intl = useIntl();

  const options = [
    {
      icon: (
        <FontAwesomeIcon
          icon={["far", "pencil" as IconName]}
          className="fa-fa mx-10 w-7 h-7"
          color="gray"
        />
      ),
      label: intl.formatMessage({ id: "courses.courseCard.renameLabel" }),
      value: "rename",
    },
    {
      icon: (
        <FontAwesomeIcon
          icon={["far", "copy" as IconName]}
          className="fa-fw mx-1 w-7 h-7"
          color="gray"
        />
      ),
      label: intl.formatMessage({ id: "courses.courseCard.duplicateLabel" }),
      value: "duplicate",
    },
    {
      icon: (
        <FontAwesomeIcon
          icon={["far", "fa-pause" as IconName]}
          className="fa-fa mx-1 w-7 h-7"
          color="gray"
        />
      ),
      label: intl.formatMessage({ id: "courses.courseStatus.PauseLabel" }),
      value: "pause",
    },
    {
      icon: (
        <FontAwesomeIcon
          icon={["far", "trash-can" as IconName]}
          className="fa-fa mx-1 w-7 h-7"
          color="gray"
        />
      ),
      label: intl.formatMessage({ id: "courses.courseStattus.DeleteLabel" }),
      value: "delete",
    },
  ];
  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();

  const [goToParticularCourse, setGoToParticularCourse] =
    useState<boolean>(false);

  const [visible, setVisible] = useState<boolean>(false);
  const [currSchedule, setCurrSchedule] = useState<any>();

  const [homeAnaly, setHomeAnaly] = useState<HomeAnalytics>(
    {} as HomeAnalytics
  );

  const [scheduleHomeScreen, setScheduleHomeScreen] = useState(true);
  const [scheduleFetchScreen, setFetchScheduleScreen] = useState(false);

  const [scheduleDetails, setScheduleDetails] = useState<GetScheduleDetails>({
    schedule: {} as ScheduleDetails,
  } as GetScheduleDetails);
  const [userScheduleDetails, setUserScheduleDetails] =
    useState<GetScheduleDetails>({
      userSchedules: [{} as UserScheduleDetails],
    } as GetScheduleDetails);

  const [schedule, setSchedule] = useState<Schedule>({
    endOption: {},
  } as Schedule);

  const [warningDialog, setWarningDialog] = useState<boolean>(false);
  const [errorFlag, setErrorFlag] = useState<boolean>(false);
  // const tenantIdRef = useRef(null);
  console.log("window width", window.innerWidth);
  console.log("hello in home");
  console.log("account role in home", accountInstance.accntRole);

  const toggleWarningDialog = () => {
    setWarningDialog(!warningDialog);
  };

  const data = [
    {
      icon: "manualCourse.png",
      iconDescription: `${intl.formatMessage({
        id: "courses.model.options.manual",
      })}`,
      disabled: false,
    },
    {
      icon: "generativeAiCourse.png",
      iconDescription: `${intl.formatMessage({
        id: "courses.model.options.generativeAi",
      })}`,
      disabled: false,
    },
    {
      icon: "generativeAiFileCourse.png",
      iconDescription: `${intl.formatMessage({
        id: "courses.model.options.generativeAiFromFile",
      })}`,
      disabled: false,
    },
    {
      icon: "catologueCourse.png",
      iconDescription: `${intl.formatMessage({
        id: "courses.model.options.fromCatalogue",
      })}`,
      disabled: true,
    },
  ];
  const goToCreateCourse = (e: string) => {
    navigate("/createCourse", { state: e });
  };

  const navigate = useNavigate();

  const [allCourses, setAllcourses] = useState<AllCourses>({
    resources: [{} as CoursesRecieved],
  } as AllCourses);

  async function apiGetCourse() {
    let api = ApiServices.getInstance();
    if (accountInstance.accntId !== "1234") {
      await api
        .makeRequest(`${accountInstance.accntId}/course?limit=30`, "GET")
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }
          console.log("Courses", res);
          let count;
          let x = {
            ...res,
            resources: res.resources.filter(
              (course: CoursesRecieved) => course.status !== "ARCHIVED"
            ),
          } as AllCourses;

          x.resources.sort(
            (a, b) =>
              new Date(b.updatedAt!!).getTime() -
              new Date(a.updatedAt!!).getTime()
          );

          const top8Courses = x.resources.slice(0, courseCount);
          setAllcourses({
            resources: top8Courses,
            resourceCount: top8Courses.length,
          });
          console.log("top 2", res);
        });
    }
  }

  const handleViewAllSchedules = () => {
    navigate("/scheduler", {
      state:
        // "Schedules"
        intl.formatMessage({ id: "schedules.title" }),
    });
  };
  const handleCreateSchedule = () => {
    navigate("/newSchedule", {
      state:
        // "Create Schedule"
        intl.formatMessage({ id: "home.createSchedule" }),
    });
  };

  const handleViewAllCourses = () => {
    navigate("/courses", {
      state:
        // "Courses"
        intl.formatMessage({ id: "home.courses" }),
    });
  };

  const toggleVisible = () => {
    setVisible(!visible);
  };
  const [allSchedules, setAllSchedules] = useState<GetSchedules>(
    {} as GetSchedules
  );

  const [count, setCount] = useState(10);
  const [courseCount, setCourseCount] = useState(10);
  console.log("print count out", count);
  console.log("print course count", courseCount);

  useEffect(
    () => {
      const handleResize = () => {
        if (window.innerWidth >= 1536) {
          setCount(10);
          console.log("inside window width", count);
        } else if (window.innerWidth >= 1280 && window.innerWidth < 1536) {
          setCount(8);
        } else if (window.innerWidth >= 1024 && window.innerWidth < 1286) {
          setCount(6);
        } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
          setCount(4);
        }
      };
      handleResize();
      // Only call schedule API when account is properly initialized (not default values)
      // and the role is authorized to view schedules
      if (
        accountInstance.accntId !== "1234" &&
        (accountInstance.accntRole === "tnt_superAdmin" ||
          accountInstance.accntRole === "tnt_admin" ||
          accountInstance.accntRole === "tnt_courseScheduler")
      ) {
        apiGetAllSchedules();
      }
      homeAnalyticsApi();
    },
    // []
    [count, accountInstance.accntId, accountInstance.accntRole]

    // [window.innerWidth]
  );

  useEffect(() => {
    const handleCourseResize = () => {
      if (window.innerWidth >= 1536) {
        setCourseCount(10);
        console.log("inside window width", count);
      } else if (window.innerWidth >= 1280 && window.innerWidth < 1536) {
        setCourseCount(10);
      } else if (window.innerWidth >= 1024 && window.innerWidth < 1286) {
        setCourseCount(8);
      } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
        setCourseCount(6);
      }
    };

    handleCourseResize();
    if (
      accountInstance.accntRole === "tnt_superAdmin" ||
      accountInstance.accntRole === "tnt_admin" ||
      accountInstance.accntRole === "tnt_contentCreator" ||
      accountInstance.accntRole === "tnt_reviewer"
    ) {
      apiGetCourse();
    }
  }, [goToParticularCourse, courseCount, accountInstance.accntId]);

  useEffect(() => {
    async function initializeAndUseAccount() {
      await accountInstance.fetchAccountId();
      console.log(
        "account id instance in tenant side",
        accountInstance.accntId
      );
    }
    initializeAndUseAccount();
  }, []);

  async function apiGetAllSchedules() {
    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      await api
        .makeRequest(`${accountInstance.accntId}/schedule?limit=10`, "GET")
        .then(async (res) => {
          // let count
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }

          if (res?.errorMessage === "PERMISSION_DENIED") {
            toggleWarningDialog();
          }
          let x = res as GetSchedules;

          x.resources.sort(
            (a, b) =>
              new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
          );
          const top8Schedules = x.resources.slice(0, count);
          setAllSchedules({
            resources: top8Schedules,
            resourceCount: top8Schedules.length,
          });
          console.log("top 2", res);
        });
    }
  }

  async function homeAnalyticsApi() {
    console.log("entered home analytics");
    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      console.log("entered tenant id check");
      await api
        .makeRequest(
          `${accountInstance.accntId}/analytics/homeAnalytics`,
          "GET"
        )
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }
          console.log("home analytics response", res);
          setHomeAnaly(res);
        });
    }
  }
  const handleViewClick = (schedule: ScheduleResource) => {
    console.log("inside schedule handle view click");
    setScheduleHomeScreen(false);
    setFetchScheduleScreen(true);
    console.log("schedule id print", schedule.scheduleId);
    getScheduleInfo(schedule.scheduleId);

    setCurrSchedule(schedule);

    console.log("schedule data inside sched home screen", schedule);
  };

  async function getScheduleInfo(
    scheduleId: string
  ): Promise<GetScheduleDetails> {
    console.log("hi i am in getScheduleInfo");
    let x: GetScheduleDetails = {} as GetScheduleDetails;

    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      x = await api
        .makeRequest(`${accountInstance.accntId}/schedule/${scheduleId}`, "GET")
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }
          setScheduleDetails(res);
          setUserScheduleDetails(res);
          console.log("get response", res);
          return res;
        });
    }
    return x as GetScheduleDetails;
  }

  return (
    <div>
      {errorFlag && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: errorInstance.errorCode,
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              setErrorFlag(false);
              navigate("/home");
            }}
          />
        </Dialog>
      )}
      <div className="w-full h-full flex flex-col space-y-10 items-center">
        {scheduleHomeScreen && (
          <div className="w-full flex flex-wrap justify-between items-center mt-2">
            <div className="pl-2 w-[25%]">
              <Stats
                data={homeAnaly.activeSchedules}
                value={`${intl.formatMessage({
                  id: "homeAnaly.activeSchedules",
                })}`}
                bgColor={"mk-pink"}
              />
            </div>

            <div className="w-[25%]">
              <Stats
                data={homeAnaly.cardWsent}
                value={`${intl.formatMessage({
                  id: "homeAnaly.cardsSentWeek",
                })}`}
                bgColor={"mk-orange"}
              />
            </div>

            <div className="w-[25%]">
              <Stats
                // data={`${homeAnaly.actUsrPcent}%` }
                data={
                  homeAnaly.actUsrPcent !== undefined
                    ? `${homeAnaly.actUsrPcent}%`
                    : ""
                }
                value={`${intl.formatMessage({
                  id: "homeAnaly.activeParticipants",
                })}`}
                bgColor={"mk-blue"}
              />
            </div>

            {/* <div className="w-[25%]"> */}
            <Stats
              data={homeAnaly.totalUserCnt}
              value={`${intl.formatMessage({ id: "homeAnaly.totalUsers" })}`}
              bgColor={"mk-green"}
            />
            {/* <TextEditorSelect></TextEditorSelect> */}
            {/* </div> */}
          </div>
        )}
      </div>

      <div>
        {warningDialog && (
          <Dialog className="errorDialogue">
            <Alert
              // description={intl.formatMessage{}}
              description={intl.formatMessage({
                id: errorInstance.errorCode,
              })}
              buttonText={`${intl.formatMessage({
                id: "users.buttonText.Ok",
              })}`}
              icon={"errorShape.png"}
              iconMsg={intl.formatMessage({
                id: "iconMsgError",
              })}
              backgroundColor={"mk-red"}
              onClick={() => {
                toggleWarningDialog();
              }}
            />
          </Dialog>
        )}

        {scheduleHomeScreen &&
          (accountInstance.accntRole === "tnt_superAdmin" ||
            accountInstance.accntRole === "tnt_admin" ||
            accountInstance.accntRole === "tnt_courseScheduler") && (
            <div className="flex items-end justify-between">
              <div className="text-mk-primary-bright text-2xl mt-8 font-semibold">
                <FormattedMessage id="home.recentSchedules" />
              </div>

              <div className="flex mt-4 gap-4 ">
                <Button
                  className="rounded bg-mk-primary-50 text-mk-primary-bright hover:bg-mk-light-grey
                                            hover:text-black focus:outline-none px-4 py-2"
                  onClick={handleViewAllSchedules}
                >
                  {/* View All */}
                  <FormattedMessage id="home.viewAll" />
                </Button>

                <Button
                  className="rounded bg-mk-primary-bright text-white hover:bg-mk-light-grey hover:text-black focus:outline-none px-4 py-2"
                  onClick={handleCreateSchedule}
                >
                  {/* Create Schedule + */}
                  <FormattedMessage id="home.createSchedule" />
                </Button>
              </div>
            </div>
          )}

        <div className="pb-[1%]"></div>

        {scheduleHomeScreen && (
          // <div className="w-full h-full grid gap-y-10 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 md:gap-12 pb-24">
          <div className="w-full h-full grid gap-y-10 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 md:gap-12">
            {allSchedules.resources?.slice(0, count).map((element, index) => {
              return (
                <ScheduleCard
                  key={index}
                  scheduleCardResourse={element}
                  homeScreenState={setScheduleHomeScreen}
                  fetchScreenState={setFetchScheduleScreen}
                  onReload={() => {
                    console.log(
                      "print organization super admin",

                      intl.formatMessage({ id: "organization.superAdmin" })
                    );
                    console.log("print accnt role", accountInstance.accntRole);
                    if (
                      accountInstance.accntRole === "tnt_superAdmin" ||
                      accountInstance.accntRole === "tnt_admin" ||
                      accountInstance.accntRole === "tnt_courseScheduler"
                    ) {
                      console.log("I am inside home of schedule card");
                      apiGetAllSchedules();
                    }
                  }}
                  currentScheduleFunction={setCurrSchedule}
                  getScheduleDetails={() => getScheduleInfo(element.scheduleId)}
                  click={() => handleViewClick(element)}
                />
              );
            })}
          </div>
        )}

        {scheduleFetchScreen && (
          <div className="w-full h-full">
            <ScheduleDetailsFetch
              currentSchedule={currSchedule}
              scheduleModel={scheduleDetails}
              schedule={schedule}
              homeScreenState={setScheduleHomeScreen}
              fetchScreenState={setFetchScheduleScreen}
            />
          </div>
        )}
      </div>
      {scheduleHomeScreen && (
        <div>
          <div className="flex items-end justify-between">
            {(accountInstance.accntRole === "tnt_superAdmin" ||
              accountInstance.accntRole === "tnt_admin" ||
              accountInstance.accntRole === "tnt_contentCreator" ||
              accountInstance.accntRole === "tnt_reviewer") && (
              <div className="text-mk-primary-bright text-2xl mt-8 font-semibold">
                <FormattedMessage id="home.recentCourses" />
              </div>
            )}

            {(accountInstance.accntRole === "tnt_superAdmin" ||
              accountInstance.accntRole === "tnt_admin" ||
              accountInstance.accntRole === "tnt_contentCreator" ||
              accountInstance.accntRole === "tnt_reviewer") && (
              <div className="flex mt-4 gap-4 ">
                {visible && (
                  <CreateModal
                    description={intl.formatMessage({
                      id: "courses.modal.description",
                    })}
                    successText={intl.formatMessage({
                      id: "courses.modal.successText",
                    })}
                    onCancel={() => setVisible(false)}
                    onSuccess={(e: string) => goToCreateCourse(e)}
                    data={data}
                  />
                )}

                <Button
                  className="rounded bg-mk-primary-50 text-mk-primary-bright hover:bg-mk-light-grey
                            hover:text-black focus:outline-none px-4 py-2"
                  onClick={handleViewAllCourses}
                >
                  <FormattedMessage id="home.viewAll" />
                </Button>

                <Button
                  className="rounded bg-mk-primary-bright text-white hover:bg-mk-light-grey hover:text-black focus:outline-none px-4 py-2"
                  onClick={toggleVisible}
                >
                  <FormattedMessage id="home.createCourse" />
                </Button>
              </div>
            )}
          </div>

          <div className="pb-[1%]"></div>

          <div className="w-full h-full justify-between grid gap-y-10 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 md:gap-12 pb-[5%]">
            {allCourses.resources
              ?.filter((course) => {
                return course.status !== "ARCHIVED";
              })
              .map((ele, i) => {
                return (
                  <CourseCard
                    key={ele.courseId}
                    backGroundImage={ele.thumbnailUrl!!}
                    handleGoToCourse={(chptId: string) => {
                      navigate("/editCourse", {
                        state: JSON.stringify({
                          name: "Edit Course",
                          data: chptId,
                        }),
                      });
                    }}
                    courseDetail={ele}
                    onReload={() => {
                      if (
                        accountInstance.accntRole === "tnt_superAdmin" ||
                        accountInstance.accntRole === "tnt_admin" ||
                        accountInstance.accntRole === "tnt_contentCreator" ||
                        accountInstance.accntRole === "tnt_reviewer"
                      ) {
                        apiGetCourse();
                      }
                    }}
                  />
                );
              })}
          </div>
        </div>
      )}
      <div className="pb-[5%]"></div>
    </div>
  );
}
